
(function(){
  var btn=document.querySelector('[data-mobile-toggle]');
  var menu=document.querySelector('[data-mobile-menu]');
  if(btn&&menu){btn.addEventListener('click',function(){menu.classList.toggle('is-open');btn.setAttribute('aria-expanded',menu.classList.contains('is-open')?'true':'false');});}
  var els=document.querySelectorAll('[data-reveal]');
  if(!('IntersectionObserver' in window)){els.forEach(function(el){el.classList.add('is-visible')});return;}
  var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target);}})},{threshold:.12});
  els.forEach(function(el){obs.observe(el)});
})();
(function(){
  function enhanceEventDateField(){
    var field=document.querySelector('input[name="contact[event_date]"]');
    if(!field)return;
    field.type='date';
    field.removeAttribute('placeholder');
    field.setAttribute('autocomplete','off');
    field.required=true;
    field.setAttribute('aria-required','true');
    field.addEventListener('click',function(){if(field.showPicker)field.showPicker();});
    field.addEventListener('focus',function(){if(field.showPicker)field.showPicker();});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',enhanceEventDateField);}else{enhanceEventDateField();}
})();

(function(){
  function insertAfter(referenceNode,newNode){
    if(referenceNode&&referenceNode.parentNode){referenceNode.parentNode.insertBefore(newNode,referenceNode.nextSibling);}
  }
  function makeInput(name,type,placeholder,attrs){
    var input=document.createElement('input');
    input.name=name;
    input.type=type;
    if(placeholder)input.placeholder=placeholder;
    Object.keys(attrs||{}).forEach(function(key){input.setAttribute(key,attrs[key]);});
    return input;
  }
  function makeSelect(name,options){
    var select=document.createElement('select');
    select.name=name;
    options.forEach(function(text){var option=document.createElement('option');option.textContent=text;option.value=text;select.appendChild(option);});
    return select;
  }
  function makeLabel(text,control){
    var label=document.createElement('label');
    label.appendChild(document.createTextNode(text));
    label.appendChild(control);
    return label;
  }
  function enhanceInquiryDetails(){
    var form=document.querySelector('#contact_form.contact-form');
    if(!form||form.dataset.ffDetailsEnhanced==='true')return;
    form.dataset.ffDetailsEnhanced='true';
    var emailLabel=form.querySelector('input[name="contact[email]"]')&&form.querySelector('input[name="contact[email]"]').closest('label');
    var packageLabel=form.querySelector('select[name="contact[package]"]')&&form.querySelector('select[name="contact[package]"]').closest('label');
    if(emailLabel&&!form.querySelector('input[name="contact[phone]"]')){
      insertAfter(emailLabel,makeLabel('Phone number',makeInput('contact[phone]','tel','(555) 555-5555',{autocomplete:'tel'})));
    }
    var phoneLabel=form.querySelector('input[name="contact[phone]"]')&&form.querySelector('input[name="contact[phone]"]').closest('label');
    if(phoneLabel&&!form.querySelector('select[name="contact[how_did_you_hear_about_us]"]')){
      insertAfter(phoneLabel,makeLabel('How did you hear about us?',makeSelect('contact[how_did_you_hear_about_us]',['Please select','Google','Instagram','Facebook','TikTok','Referral from a friend','Wedding vendor / planner','Venue recommendation','Event or expo','Other'])));
    }
    if(packageLabel&&!form.querySelector('select[name="contact[event_type]"]')){
      var eventTypeSelect=makeSelect('contact[event_type]',['Please select','Wedding','Corporate event','Private party','Brand activation','Birthday','Other']);
      eventTypeSelect.options[0].value='';
      eventTypeSelect.required=true;
      eventTypeSelect.setAttribute('aria-required','true');
      form.insertBefore(makeLabel('Event type',eventTypeSelect),packageLabel);
    }
    var eventTypeField=form.querySelector('select[name="contact[event_type]"]');
    if(eventTypeField){
      eventTypeField.required=true;
      eventTypeField.setAttribute('aria-required','true');
      if(eventTypeField.options[0]&&eventTypeField.options[0].value==='Not sure yet'){eventTypeField.options[0].value='';eventTypeField.options[0].textContent='Please select';}
    }
    if(packageLabel&&!form.querySelector('input[name="contact[event_location]"]')){
      form.insertBefore(makeLabel('Venue / location',makeInput('contact[event_location]','text','Venue or city',{autocomplete:'street-address'})),packageLabel);
    }
    if(packageLabel&&!form.querySelector('input[name="contact[guest_count]"]')){
      form.insertBefore(makeLabel('Guest count',makeInput('contact[guest_count]','number','Estimated guest count',{min:'1',inputmode:'numeric'})),packageLabel);
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',enhanceInquiryDetails);}else{enhanceInquiryDetails();}
})();

(function(){
  function addPremiumConversionBlocks(){
    var inquiry=document.querySelector('#inquiry');
    if(!inquiry)return;
    if(!document.getElementById('ff-premium-conversion-style')){
      var style=document.createElement('style');
      style.id='ff-premium-conversion-style';
      style.textContent='#inquiry .inquiry__trust{list-style:none;margin:28px 0 0;padding:0;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}#inquiry .inquiry__trust li{display:flex;align-items:center;gap:9px;border:1px solid var(--line);border-radius:999px;padding:10px 12px;background:rgba(238,236,233,.07);color:var(--ff-cream);font-family:var(--ff-mono);font-size:.68rem;letter-spacing:.11em;text-transform:uppercase}#inquiry .inquiry__trust li:before{content:"";width:6px;height:6px;border-radius:999px;background:var(--ff-sage);flex:0 0 6px}.final-cta{background:linear-gradient(135deg,var(--ff-espresso),var(--ff-deep));border-top:1px solid rgba(238,236,233,.12);border-bottom:1px solid rgba(238,236,233,.1)}.final-cta__inner{max-width:900px;margin:0 auto;text-align:center;display:grid;justify-items:center;gap:18px}.final-cta h2{max-width:820px}.final-cta p:not(.eyebrow){max-width:650px;color:var(--muted);margin:0}.final-cta .button{margin-top:6px}@media (max-width:640px){#inquiry .inquiry__trust{grid-template-columns:1fr}.final-cta__inner{text-align:left;justify-items:start}}';
      document.head.appendChild(style);
    }
    var intro=inquiry.querySelector('.inquiry__grid > div');
    if(intro&&!intro.querySelector('.inquiry__trust')){
      var trust=document.createElement('ul');
      trust.className='inquiry__trust';
      trust.setAttribute('aria-label','Booking trust highlights');
      ['Fully attended setup','Insured + venue-ready','Professional camera + studio lighting','Fast gallery delivery'].forEach(function(text){var item=document.createElement('li');item.textContent=text;trust.appendChild(item);});
      intro.appendChild(trust);
    }
    if(!document.querySelector('.final-cta')){
      var cta=document.createElement('section');
      cta.className='final-cta section is-visible';
      cta.innerHTML='<div class="page-width final-cta__inner"><p class="eyebrow">Ready when you are</p><h2>Let’s make your event impossible to forget.</h2><p>Tell us your date and a few details, and we’ll help shape a polished photo booth experience around your event.</p><a class="button button--cream" href="#inquiry">Check Availability</a></div>';
      inquiry.parentNode.insertBefore(cta,inquiry.nextSibling);
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',addPremiumConversionBlocks);}else{addPremiumConversionBlocks();}
})();



(function(){


  function isContactSuccess(){
    var params=new URLSearchParams(window.location.search);
    return params.get('contact_posted')==='true';
  }

  function hideInlineSuccessMessages(){
    var successText=['thanks for contacting','thank you','we will be in touch','we’ll be in touch'];
    Array.prototype.slice.call(document.querySelectorAll('.form-status,.form__message,[role="status"],.contact__message,.errors,.note')).forEach(function(el){
      var text=(el.textContent||'').toLowerCase();
      if(successText.some(function(phrase){return text.indexOf(phrase)>-1;})){
        el.setAttribute('hidden','hidden');
        el.style.display='none';
      }
    });
  }

  function addModalStyles(){
    if(document.getElementById('ff-inquiry-modal-style'))return;
    var style=document.createElement('style');
    style.id='ff-inquiry-modal-style';
    style.textContent='.ff-inquiry-modal{position:fixed;inset:0;z-index:9999;display:grid;place-items:center;padding:24px;background:rgba(24,31,27,.52);backdrop-filter:blur(6px);opacity:0;pointer-events:none;transition:opacity .22s ease}.ff-inquiry-modal.is-open{opacity:1;pointer-events:auto}.ff-inquiry-modal__dialog{width:min(92vw,460px);background:#f8f4ee;color:#18311f;border:1px solid rgba(24,49,31,.18);box-shadow:0 24px 70px rgba(0,0,0,.28);padding:34px 30px;text-align:center}.ff-inquiry-modal__mark{width:42px;height:42px;margin:0 auto 18px;border:1px solid rgba(24,49,31,.24);display:grid;place-items:center;border-radius:50%;font-size:21px;line-height:1}.ff-inquiry-modal h2{margin:0 0 12px;font-family:var(--font-heading-family,serif);font-size:clamp(1.65rem,3vw,2.2rem);font-weight:400;letter-spacing:0;color:#18311f}.ff-inquiry-modal p{margin:0 auto 24px;max-width:34ch;font-size:1rem;line-height:1.65;color:rgba(24,49,31,.74)}.ff-inquiry-modal__button{appearance:none;border:1px solid #18311f;background:#18311f;color:#f8f4ee;min-height:46px;padding:0 26px;font:inherit;letter-spacing:.04em;text-transform:uppercase;cursor:pointer}.ff-inquiry-modal__button:hover{background:#253f2c}.ff-inquiry-modal__close{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)}@media(max-width:520px){.ff-inquiry-modal__dialog{padding:30px 22px}.ff-inquiry-modal p{font-size:.96rem}}';
    document.head.appendChild(style);
  }

  function showInquiryModal(){
    if(!isContactSuccess()||document.getElementById('ff-inquiry-modal'))return;
    hideInlineSuccessMessages();
    addModalStyles();
    var modal=document.createElement('div');
    modal.id='ff-inquiry-modal';
    modal.className='ff-inquiry-modal';
    modal.setAttribute('role','dialog');
    modal.setAttribute('aria-modal','true');
    modal.setAttribute('aria-labelledby','ff-inquiry-modal-title');
    modal.innerHTML='<div class="ff-inquiry-modal__dialog"><div class="ff-inquiry-modal__mark" aria-hidden="true">✓</div><h2 id="ff-inquiry-modal-title">Thank you — we’ll be in touch soon.</h2><p>We received your inquiry and will follow up shortly with availability, details, and next steps for your event.</p><button class="ff-inquiry-modal__button" type="button">Close</button></div>';
    document.body.appendChild(modal);
    var closeButton=modal.querySelector('button');
    function closeModal(){
      modal.classList.remove('is-open');
      document.body.style.overflow='';
      setTimeout(function(){modal.remove();},220);
      var cleanUrl=new URL(window.location.href);
      cleanUrl.searchParams.delete('contact_posted');
      window.history.replaceState({},'',cleanUrl.pathname+cleanUrl.search+cleanUrl.hash);
    }
    modal.addEventListener('click',function(event){if(event.target===modal)closeModal();});
    closeButton.addEventListener('click',closeModal);
    document.addEventListener('keydown',function onKeydown(event){
      if(event.key==='Escape'){document.removeEventListener('keydown',onKeydown);closeModal();}
    });
    document.body.style.overflow='hidden';
    requestAnimationFrame(function(){modal.classList.add('is-open');closeButton.focus();});
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',showInquiryModal);}else{showInquiryModal();}
})();


(function(){
  function hideContactPostedInline(){
    var params=new URLSearchParams(window.location.search);
    var shouldHide=params.get('contact_posted')==='true'||document.getElementById('ff-inquiry-modal');
    if(!shouldHide)return;
    Array.prototype.slice.call(document.querySelectorAll('form *')).forEach(function(el){
      var text=(el.textContent||'').trim().toLowerCase();
      var looksLikeThanks=text.indexOf('thank you')>-1&&text.indexOf('touch soon')>-1;
      if(looksLikeThanks){
        el.setAttribute('hidden','hidden');
        el.style.display='none';
      }
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',hideContactPostedInline);}else{hideContactPostedInline();}
  setTimeout(hideContactPostedInline,250);
  setTimeout(hideContactPostedInline,1000);
})();


(function(){
  function addServiceFooterLinks(){
    var grid=document.querySelector('.footer .footer__grid');
    if(!grid)return;
    var explore=null;
    Array.prototype.slice.call(grid.children).some(function(block){
      var heading=block.querySelector('h3');
      if(heading&&heading.textContent.trim()==='Explore'){explore=block;return true;}
      return false;
    });
    if(!explore)return;
    var contact=explore.querySelector('a[href*="#inquiry"]');
    var links=[
      ['/pages/wedding-photo-booth-rental-austin','Wedding Photo Booth Rental Austin'],
      ['/pages/corporate-photo-booth-rental-austin','Corporate Photo Booth Rental Austin'],
      ['/pages/private-event-photo-booth-austin','Private Event Photo Booth Austin'],
      ['/pages/austin-photo-booth-planning-guide','Photo Booth Planning Guide']
    ];
    links.forEach(function(item){
      if(explore.querySelector('a[href="'+item[0]+'"]'))return;
      var link=document.createElement('a');
      link.href=item[0];
      link.textContent=item[1];
      explore.insertBefore(link,contact);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',addServiceFooterLinks);
  else addServiceFooterLinks();
})();